import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Form, Button } from 'react-bootstrap'
import InputText from '../commons/form/InputText'
import FaqTable from '../../containers/faq/FaqTablePage'
import FaqSections from '../../containers/faq/FaqSectionsPage'
import FaqModal from '../../containers/faq/FaqModalPage'
import { handleKeyDown } from '../../util/utils'
import MapSections from '../../util/map-sections_v2'

class Faq extends PureComponent {
  constructor () {
    super()
    this.state = {
      isSearching: false,
      showModal: false,
      questionId: null,
      sectionId: null,
      sectionTitle: null,
      search: null
    }
  }

  openOrCloseModal (flag) {
    this.setState({ showModal: flag })
  }

  openOrCloseTable (flag) {
    this.setState({ isSearching: flag })
  }

  openQuestion (questionId) {
    this.setState({ questionId: questionId })
    this.openOrCloseModal(true)
  }

  openSection (sectionId, sectionTitle) {
    this.setState({ sectionId: sectionId, sectionTitle: sectionTitle })
    this.openOrCloseTable(true)
  }

  handleSubmit () {
    if (this.props && this.props.formValues && this.props.formValues.filters && this.props.formValues.filters.search) {
      this.setState({ search: this.props.formValues.filters.search })
      this.openOrCloseTable(true)
    }
  }

  goBack () {
    if (this.state.isSearching) {
      this.setState({ search: null, questionId: null, sectionId: null, isSearching: false })
      this.openOrCloseModal(false)
    }
  }

  render () {
    const {
      t
    } = this.props

    const secMap = MapSections.faq
    const tKey = 'FAQ.'
    return (
      <>
        <div id='faq' className="wrapper _nf">
          <div className='wrapper-header'>
            <div className="title-page">
              <i className={secMap.icon + ' icon-page'} />
              <h2>{t(`${secMap.title}`)}</h2>
            </div>
          </div>
          <div className='wrapper-body'>
            <div className='inner-data-content faq'>
              <div className="inner-results-panel">
                <div className="section-results-header">
                  <div className="section-header-title">
                    <h4>{t(`${tKey}TITLE`)}</h4>
                  </div>
                  <div className='filters'>
                    <span className="title-search">
                      {t(`${tKey}SEARCH.TITLE`)}
                    </span>
                    <div className="search-form">
                      {!this.state.isSearching &&
                      <Form autoComplete="off" className="filters" onSubmit={() => this.handleSubmit()} onKeyDown={(e) => handleKeyDown(e)}>
                        <Field
                          component={InputText}
                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                          id="search"
                          name="filters.search"
                          placeholder={t(`${tKey}SEARCH.SEARCH`)}
                        />
                        <div className="search-form-actions flexInLine al-R">
                          <Button
                            className={'_Btn accept'}
                            type="submit"
                          >
                            <i className="ico-search" />
                            {t(`${tKey}SEARCH.SEARCH_BTN`)}
                          </Button>
                        </div>
                      </Form>
                      }
                    </div>
                  </div>
                </div>
                <div className='section-results-body'>
                  <div className={'searchResoultsContainer'}>
                    <div className="table-wrapper" key="table-wrapper">
                      {/* table */}
                      { this.state.isSearching &&
                      <div className="go-back">
                        <Button className="_Btn accept o-icn stk" onClick={() => this.goBack()}>
                          <i className="iDocIcon-arrow-left-back"/>
                        </Button>
                        <div className="go-back-text" onClick={() => this.goBack()}>
                          {t(`${tKey}SEARCH.FAQ`)}
                        </div>
                        {
                          (this.state.search || this.state.sectionTitle) && [
                            <div key={1} className="go-back-search-text">
                              {'->'}
                            </div>,
                            <div key={2} className="go-back-search-text">
                              "{this.state.search ? this.state.search : this.state.sectionTitle}"
                            </div>
                          ]
                        }
                      </div>
                      }
                      {
                        this.state && this.state.isSearching ? (
                          <FaqTable
                            t={t}
                            sectionId={this.state.sectionId}
                            openQuestion={(questionId) => this.openQuestion(questionId)}
                            search={this.state.search}
                          />
                        ) : this.state && !this.state.isSearching ? (
                          <FaqSections
                            t={t}
                            openQuestion={(questionId) => this.openQuestion(questionId)}
                            openSection={(sectionId, sectionTitle) => this.openSection(sectionId, sectionTitle)}
                          />
                        ) : null
                      }
                    </div>
                  </div>
                </div>

                <FaqModal
                  t={t}
                  showModal={this.state.showModal}
                  questionId={this.state.questionId}
                  closeModal={() => this.openOrCloseModal(false)}
                />
              </div>
            </div>
          </div>
        </div>

      </>

    )
  }
}

export default reduxForm({
  form: 'faq'
})(Faq)
